import React from 'react';
import { FiCheckCircle, FiAlertTriangle, FiXCircle } from 'react-icons/fi';
import { getNormalizedBlockStatus } from '../../../../../utils/statusUtils';
import './HealthStatusCards.css';

const HealthStatusCards = ({ blocks = [] }) => {
  const healthStats = React.useMemo(() => {
    const stats = {
      healthy: 0,
      warning: 0,
      critical: 0,
      total: blocks.length,
    };

    // Process each block and calculate health statistics
    blocks.forEach((block) => {
      // Use the normalized status function for consistency across all components
      const normalizedStatus = getNormalizedBlockStatus(
        block, 
        block.activeErrors || block.errors || [], 
        block.activeWarnings || block.warnings || []
      );
      
      const status = normalizedStatus.status;

      if (Object.prototype.hasOwnProperty.call(stats, status)) {
        stats[status]++;
      } else {
        console.warn(`⚠️ Unknown status: ${status} for block ${block.serial}`, { 
          block, 
          normalizedStatus 
        });
      }
    });
    return stats;
  }, [blocks]);

  const getHealthPercentage = (count) => {
    if (healthStats.total === 0) return 0;
    return Math.round((count / healthStats.total) * 100);
  };

  return (
    <div className="health-status-cards">
      <div className="dashboard-stats">
        {/* Critical Status Card */}
        <div className="health-card critical">
          <div className="health-icon">
            <FiXCircle />
          </div>
          <div className="health-value">{healthStats.critical}</div>
          <div className="health-label">Critical</div>
          <div className="health-percentage">
            {getHealthPercentage(healthStats.critical)}% of devices
          </div>
        </div>

        {/* Warning Status Card */}
        <div className="health-card warning">
          <div className="health-icon">
            <FiAlertTriangle />
          </div>
          <div className="health-value">{healthStats.warning}</div>
          <div className="health-label">Warning</div>
          <div className="health-percentage">
            {getHealthPercentage(healthStats.warning)}% of devices
          </div>
        </div>

        {/* Healthy Status Card */}
        <div className="health-card healthy">
          <div className="health-icon">
            <FiCheckCircle />
          </div>
          <div className="health-value">{healthStats.healthy}</div>
          <div className="health-label">Healthy</div>
          <div className="health-percentage">
            {getHealthPercentage(healthStats.healthy)}% of devices
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthStatusCards;
